// extracted by mini-css-extract-plugin
export default {"container":"back-header_container__11GBG","link":"back-header_link__3GSbT","back":"back-header_back__sQI8v"};